import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  balance: null,

  paymentMethods: null,

  transferStatus: null,

  depositHistory: null,
  transferHistory: null,
  paymentHistory: null,
  withdrawHistory: null,

}

export const balanceSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {
    setBalance: (state, action) => { state.balance = action.payload },

    setPaymentMethods: (state, action) => { state.paymentMethods = action.payload },

    setTransferStatus: (state, action) => { state.transferStatus = action.payload },

    setDepositHistory: (state, action) => { state.depositHistory = action.payload },
    setTransferHistory: (state, action) => { state.transferHistory = action.payload },
    setPaymentHistory: (state, action) => { state.paymentHistory = action.payload },
    setWithdrawHistory: (state, action) => { state.withdrawHistory = action.payload },


    resetBalance: () => initialState,
  },
})

export const {
  setBalance,

  setPaymentMethods,

  setTransferStatus,

  setDepositHistory,
  setTransferHistory,
  setPaymentHistory,
  setWithdrawHistory,

  resetBalance,
} = balanceSlice.actions

export default balanceSlice.reducer
